module.exports = __webpack_public_path__ + "static/TEM-c22c4ee52df91515150a7689c25a3579.jpg";